const names = (people) => people.length <= 1 ? (people[0]?.name ?? '') : `${people.slice(0, -1).map((p) => p.name).join(', ')} ve ${people.at(-1).name}`;
/** "23 dk", "1 sa 5 dk", "1 dakikadan kısa". */
export function callLength(seconds) {
    const minutes = Math.round(seconds / 60);
    if (minutes < 1)
        return '1 dakikadan kısa';
    if (minutes < 60)
        return `${minutes} dk`;
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return rest === 0 ? `${hours} sa` : `${hours} sa ${rest} dk`;
}
/** The line in Turkish, the same on every app; the server also stores it as the message's text for older apps. */
export function systemText(event) {
    switch (event.type) {
        case 'call.started':
            return event.by ? `${event.by.name} görüşme başlattı` : 'Görüşme başladı';
        case 'call.ended': {
            const head = event.by ? `Görüşmeyi ${event.by.name} sonlandırdı` : 'Görüşme bitti';
            return event.people.length > 0 ? `${head} · ${callLength(event.seconds)} · ${names(event.people)}` : `${head} · ${callLength(event.seconds)}`;
        }
        case 'screen.started':
            return `${event.by.name} ekranını paylaşmaya başladı`;
        case 'member.added':
            return `${event.by.name} kanala ekledi: ${names(event.people)}`;
        case 'member.left':
            return `${event.user.name} kanaldan ayrıldı`;
        case 'member.removed':
            return `${event.by.name} kanaldan çıkardı: ${event.user.name}`;
        case 'member.joined':
            return `${event.user.name} kanala geri katıldı`;
        case 'channel.renamed':
            return `${event.by.name} kanalın adını “${event.to}” yaptı`;
        case 'channel.topic':
            return event.topic ? `${event.by.name} kanalın konusunu “${event.topic}” yaptı` : `${event.by.name} kanalın konusunu kaldırdı`;
        case 'channel.archived':
            return `${event.by.name} kanalı arşivledi`;
        case 'channel.restored':
            return `${event.by.name} kanalı arşivden geri açtı`;
        case 'owner.granted':
            return `${event.by.name} sahiplik verdi: ${event.user.name}`;
        case 'owner.revoked':
            return event.by.id === event.user.id ? `${event.user.name} sahiplikten çekildi` : `${event.by.name} sahipliği aldı: ${event.user.name}`;
        case 'owner.handed':
            return `Sahiplik devredildi: ${event.user.name} (önceki sahibin erişimi kalktı)`;
    }
}
//# sourceMappingURL=system.js.map